import React from 'react';

const iconUserBar = '/icons/icon-user-bar.png';
import './IconUserBar.style.scss';

const IconUserBar = () => {
  return (
    <div className="icon-user-bar">
      <img src={iconUserBar} alt="Icone de Balão" />
    </div>
  );
};

export default IconUserBar;
